import React, { Component } from "react";
import { injectIntl, FormattedHTMLMessage } from "react-intl";
import { connect } from "react-redux";
import { personalInformation } from "shared/store/actions";
import selectors from "shared/store/selectors";
import {
  PaddedContainer,
  Input,
  Notes,
  SimpleSelectBox,
  FormElementContainer,
  SelectBox,
  Options,
  Label,
} from "components";
import { FORM_KEYS } from "shared/constant";
import arrOptions from "shared/constant/arrOptions";
import validation from "shared/validations";
import MonthYearInput from "../../../components/MonthYearInput";
import CardLastFourInput from "../../../components/CardLastFourInput";

class BankDetails extends Component {
  onElementChange = (e) => {
    const fieldName = e.target.name;
    const fieldValue = e.target.value;

    if (fieldName === FORM_KEYS.BANK.BANK_ACCT_FORMAT) {
      const parseValue = fieldValue === "iban";
      this.props.onUpdateBankDetails(fieldName, parseValue);
    } else {
      this.props.onUpdateBankDetails(fieldName, fieldValue);
    }
  };

  onCardChange = (e) => {
    // this.props.onUpdateBankDetails(e.name, e.value);
  };

  onHandleSelect = (name, value) => {
    // console.log('select ', name, value);
    if (name && value) this.props.onUpdateBankDetails(name, value);
  };

  render() {
    const {
      intl,
      bankName,
      accountName,
      backAcctFormat,
      iban,
      currency,
      otherBankName,
      domicileCountry,
      swift,
      routingNumber,
      formOptions: { banks, currencies },
      isSubmitClicked,
      usingKnet,
      cardInfo,
      typeOfInvestment,
      onUpdateCardLast4Digits,
      onUpdateCardMoYr,
    } = this.props;
    const { BANK } = FORM_KEYS;
    const { countries } = arrOptions;
    const isIban = !!(backAcctFormat === "iban");

    // do not include industrial bank in the list and sort it in asc order
    const alphabeticalBanks = banks
      .filter((item) => item.id !== "NW-MAR-BANK-IND")
      .map((bank) => ({
        ...bank,
        displayName: intl.formatMessage({ id: bank.label }),
      }))
      .sort((prevItem, nextItem) =>
        prevItem.displayName.localeCompare(nextItem.displayName),
      );
    // const indexOfOthers = [...alphabeticalBanks].findIndex(i => i.displayName === 'Others' || i.displayName === 'أخرى');
    const indexOfOthers = [...alphabeticalBanks].findIndex(
      (i) => i.id === "NW-MAR-BANK-OTH",
    );
    let bankListOptions = [...alphabeticalBanks];
    bankListOptions = [
      ...bankListOptions.slice(0, indexOfOthers),
      ...bankListOptions.slice(indexOfOthers + 1),
      bankListOptions[indexOfOthers],
    ];

    const elementValidation = {
      [BANK.BANK_NAME]: {
        isValid: validation
          .bankFieldsSchema(intl, BANK.BANK_NAME)
          .isValidSync({ bankName }),
        errorMessage: validation.getErrorMessages(
          { bankName },
          validation.bankFieldsSchema(intl, BANK.BANK_NAME),
        ),
      },
      [BANK.OTHER_BANK_NAME]: {
        isValid: validation
          .otherBankSchema(intl, bankName)
          .isValidSync({ otherBankName }),
        errorMessage: validation.getErrorMessages(
          { otherBankName },
          validation.otherBankSchema(intl, bankName),
        ),
      },
      [BANK.DOMICILE_COUNTRY]: {
        isValid: validation
          .domicileCountrySchema(intl, bankName)
          .isValidSync({ domicileCountry }),
        errorMessage: validation.getErrorMessages(
          { domicileCountry },
          validation.domicileCountrySchema(intl, bankName),
        ),
      },
      [BANK.ACCOUNT_NAME]: {
        isValid: validation
          .bankFieldsSchema(intl, BANK.ACCOUNT_NAME)
          .isValidSync({ accountName }),
        errorMessage: validation.getErrorMessages(
          { accountName },
          validation.bankFieldsSchema(intl, BANK.ACCOUNT_NAME),
        ),
      },
      [BANK.IBAN]: {
        isValid: validation
          .bankFieldsSchema(intl, BANK.IBAN, isIban)
          .isValidSync({ iban }), // BE68539007547034
        errorMessage: validation.getErrorMessages(
          { iban },
          validation.bankFieldsSchema(intl, BANK.IBAN, isIban),
        ),
      },
      [BANK.CURRENCY]: {
        isValid: validation
          .bankFieldsSchema(intl, BANK.CURRENCY)
          .isValidSync({ currency }),
        errorMessage: validation.getErrorMessages(
          { currency },
          validation.bankFieldsSchema(intl, BANK.CURRENCY),
        ),
      },
    };

    return (
      <PaddedContainer isRtl={this.props.appLanguage.locale === 'AR'}>
        <Notes
          msg={
            <div>
              <FormattedHTMLMessage id="info.bankDetails.desc" />
            </div>
          }
        />
        <FormElementContainer>
          <SelectBox
            label={intl.formatMessage({ id: "bankDetails.bankName" })}
            placeholder={`${intl.formatMessage({ id: "select" })} ${intl.formatMessage({ id: "bankDetails.bankName" })}`}
            dataList={bankListOptions}
            name={BANK.BANK_NAME}
            onSelect={this.onHandleSelect}
            defaultValue={bankName}
            isSearchInputDisabled={false}
            isValid={elementValidation[BANK.BANK_NAME].isValid}
            errorMessage={elementValidation[BANK.BANK_NAME].errorMessage}
            isSubmitClicked={isSubmitClicked}
          />

          {/* IF OTHERS IS SELECTED ABOVE, SPECIFY THE OTHER BANK BELOW */}
          {bankName === "NW-MAR-BANK-OTH" && (
            <>
              <Input
                label={intl.formatMessage({ id: "bankDetails.others" })}
                placeholder={`${intl.formatMessage({ id: "enter" })} ${intl.formatMessage({ id: "bankDetails.otherBankName" })}`}
                name={BANK.OTHER_BANK_NAME}
                onInputChange={this.onElementChange}
                value={otherBankName}
                isValid={elementValidation[BANK.OTHER_BANK_NAME].isValid}
                errorMessage={
                  elementValidation[BANK.OTHER_BANK_NAME].errorMessage
                }
                isSubmitClicked={isSubmitClicked}
              />
              <SimpleSelectBox
                label={intl.formatMessage({
                  id: "bankDetails.domicileCountry",
                })}
                placeholder={`${intl.formatMessage({ id: "select" })} ${intl.formatMessage({ id: "bankDetails.domicileCountry" }).toLowerCase()}`}
                dataList={countries}
                name={BANK.DOMICILE_COUNTRY}
                onSelect={this.onHandleSelect}
                defaultValue={domicileCountry}
                isSearchInputDisabled={false}
                isValid={elementValidation[BANK.DOMICILE_COUNTRY].isValid}
                errorMessage={
                  elementValidation[BANK.DOMICILE_COUNTRY].errorMessage
                }
                isSubmitClicked={isSubmitClicked}
              />
            </>
          )}

          <Input
            label={intl.formatMessage({ id: "bankDetails.accountName" })}
            placeholder={`${intl.formatMessage({ id: "enter" })} ${intl.formatMessage({ id: "bankDetails.accountName" })}`}
            name={BANK.ACCOUNT_NAME}
            onInputChange={this.onElementChange}
            value={accountName}
            isValid={elementValidation[BANK.ACCOUNT_NAME].isValid}
            errorMessage={elementValidation[BANK.ACCOUNT_NAME].errorMessage}
            isSubmitClicked={isSubmitClicked}
          />

          <FormElementContainer>
            <Label
              label={intl.formatMessage({ id: "bankDetails.accountFormat" })}
            />
            <Options
              isMultpleElements
              type="radio"
              hasContainer
              name={BANK.BANK_ACCT_FORMAT}
              optionList={[
                {
                  id: "iban",
                  label: "iban",
                },
                {
                  id: "nonIban",
                  label: "nonIban",
                },
              ]}
              onCheckMarkChange={this.onElementChange}
              defaultValue={backAcctFormat}
              // isValid={elementValidation[BANK.BANK_ACCT_FORMAT].isValid}
              // errorMessage={elementValidation[BANK.BANK_ACCT_FORMAT].errorMessage}
              isSubmitClicked={isSubmitClicked}
            />
          </FormElementContainer>

          <Input
            label={intl.formatMessage({
              id: isIban ? "bankDetails.iBan" : "bankDetails.acctNo",
            })}
            placeholder={`${intl.formatMessage({ id: "enter" })} ${intl.formatMessage({ id: isIban ? "bankDetails.iBan" : "bankDetails.acctNo" })}`}
            name={BANK.IBAN}
            onInputChange={this.onElementChange}
            value={iban}
            isValid={elementValidation[BANK.IBAN].isValid}
            errorMessage={elementValidation[BANK.IBAN].errorMessage}
            isSubmitClicked={isSubmitClicked}
          />

          <SelectBox
            label={intl.formatMessage({ id: "bankDetails.currency" })}
            placeholder={`${intl.formatMessage({ id: "select" })} ${intl.formatMessage({ id: "bankDetails.currency" })}`}
            dataList={currencies}
            name={BANK.CURRENCY}
            onSelect={this.onHandleSelect}
            defaultValue={currency}
            isSearchInputDisabled={false}
            isValid={elementValidation[BANK.CURRENCY].isValid}
            errorMessage={elementValidation[BANK.CURRENCY].errorMessage}
            isSubmitClicked={isSubmitClicked}
          />

          <Input
            label={intl.formatMessage({ id: "bankDetails.swift" })}
            placeholder={`${intl.formatMessage({ id: "enter" })} ${intl.formatMessage({ id: "bankDetails.swift" })}`}
            name={BANK.SWIFT_NUMBER}
            onInputChange={this.onElementChange}
            value={swift}
            isSubmitClicked={isSubmitClicked}
          />

          <Input
            label={intl.formatMessage({ id: "bankDetails.routingNumber" })}
            placeholder={`${intl.formatMessage({ id: "enter" })} ${intl.formatMessage({ id: "bankDetails.routingNumber" })}`}
            name={BANK.ROUTING_NUMBER}
            onInputChange={this.onElementChange}
            value={routingNumber}
            isSubmitClicked={isSubmitClicked}
          />
        </FormElementContainer>

        {typeOfInvestment === "NW-MAR-IEY-OLT" ||
        typeOfInvestment === "NW-MAR-CLA-OLT" ? (
          <React.Fragment>
            <hr />
            <FormElementContainer>
              <Label
                label={intl.formatMessage({ id: "bankDetails.useKNET" })}
              />
              <Options
                isMultpleElements
                type="radio"
                hasContainer
                name={BANK.USING_KNET}
                optionList={[
                  {
                    id: "false",
                    label: "no",
                  },
                  {
                    id: "true",
                    label: "yes",
                  },
                ]}
                onCheckMarkChange={this.onElementChange}
                defaultValue={usingKnet}
                // isValid={elementValidation[BANK.BANK_ACCT_FORMAT].isValid}
                // errorMessage={elementValidation[BANK.BANK_ACCT_FORMAT].errorMessage}
                isSubmitClicked={isSubmitClicked}
              />
            </FormElementContainer>

            <Notes
              msg={intl.formatMessage({ id: "bankDetails.useKNET.notes" })}
            />

            {usingKnet === "true" || usingKnet === true ? (
              <React.Fragment>
                {cardInfo.map((item, index) => {
                  // Card 1 is required; other cards become required once any field is filled
                  const isCardRequired = index === 0 || !!(item.lastFourDigits || item.value);
                  return (
                    <div key={`card-${index}`} className="card-info">
                      <p>
                        <strong>{`Card ${index + 1}`}</strong>
                      </p>
                      <div className="card-info__item">
                        <section>
                          <CardLastFourInput
                            intl={intl}
                            label={intl.formatMessage({
                              id: "bankDetails.last4digits",
                            })}
                            placeholder={`${intl.formatMessage({ id: "enter" })} ${intl.formatMessage({ id: "bankDetails.last4digits" })}`}
                            name="lastFourDigits"
                            required={isCardRequired}
                            onChange={(e) => {
                              onUpdateCardLast4Digits(index, e.value, e.error);
                            }}
                            value={item.lastFourDigits}
                          />
                        </section>
                        <section>
                          <MonthYearInput
                            intl={intl}
                            label={intl.formatMessage({
                              id: "bankDetails.cardExpiry",
                            })}
                            name="monthYear"
                            required={isCardRequired}
                            value={item.value}
                            error={item.error}
                            onChange={({ name, month, year, value, error }) => {
                              onUpdateCardMoYr(index, month, year, value, error);
                            }}
                          />
                        </section>
                      </div>
                    </div>
                  );
                })}
              </React.Fragment>
            ) : null}
          </React.Fragment>
        ) : null}
      </PaddedContainer>
    );
  }
}

const mapStateToProps = (state) => ({
  appLanguage: selectors.getLanguage(state),
  formOptions: selectors.getFormOptions(state),
  bankName: selectors.getBankName(state),
  otherBankName: selectors.getOtherBankName(state),
  domicileCountry: selectors.getDomicileCountry(state),
  accountName: selectors.getAccountName(state),
  backAcctFormat: selectors.getBankAcctFormat(state),
  swift: selectors.getswift(state),
  routingNumber: selectors.getRoutingNumber(state),
  iban: selectors.getIban(state),
  currency: selectors.getCurrency(state),
  isSubmitClicked: selectors.getIsFormSubmitted(state),
  usingKnet: selectors.getUsingKNET(state),
  cardInfo: selectors.getCardInfo(state),
  typeOfInvestment: selectors.getTypeOfInvestment(state),
});
const mapDispatchToProps = (dispatch) => ({
  onUpdateBankDetails: (name, value) => {
    dispatch(personalInformation.updateBankDetails(name, value));
  },
  onUpdateCardLast4Digits: (index, value, error) =>
    dispatch(personalInformation.updateLastFourDigits(index, value, error)),
  onUpdateCardMoYr: (index, mo, yr, value, error) =>
    dispatch(personalInformation.updateCardMoYr(index, mo, yr, value, error)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(BankDetails));
